import { Card } from '../card';
interface INoteCardProps {
  title: string;
  desc: string;
}

export const NoteCard: React.FC<INoteCardProps> = ({ title, desc }) => {
  return (
    <div className="rounded-lg p-[30px] bg-white group">
      <h3 className="text-base text-primary font-500">{title}</h3>
      <div className="text-sm font-400 text-primary mt-2 active-a group-has-[p]:leading-normal group-has-[p]:break-all" dangerouslySetInnerHTML={{ __html: desc }}/>
    </div>
  );
};
